/**
 * Retrieves the direct child elements of a given element, optionally filtered by a class name.
 *
 * @param {HTMLElement | Element | null | undefined} el - The parent element.
 * @param {string} [classSelector] - Optional class name to filter the direct children.
 * @returns {HTMLElement[]} An array of direct child elements that match the optional class selector.
 */
export const getDirectChildren = (
    el: HTMLElement | Element | null | undefined,
    classSelector?: string,
): HTMLElement[] => {
    if (!el) {
        return [];
    }

    const directChildren = Array.from(el.children).filter((child) =>
        classSelector ? child.classList.contains(classSelector) : true,
    ) as HTMLElement[];

    return directChildren;
};
